import styled, { css } from 'styled-components';

import { Media } from '../../assets/Mixins.style';

import { Button as commonButton } from '../../assets/Common/Button.style';

export const Box = styled.div`
  display: flex;

  ${Media.lg`
    justify-content: center;
    flex-wrap: wrap;
  `}
`;

export const Button = styled.button`
  ${commonButton}
  margin-right: 10px;

  &:last-of-type {
    margin-right: 0;

    ${Media.lg`
      margin: 5px;
    `}
  }

  ${Media.lg`
    margin: 5px;
  `}
`;

export const ButtonIcon = styled.i`
  margin-left: -5px;
  margin-right: 5px;
`;

export const Dropdown = styled.div`
  position: relative;
  display: block;
  margin-left: 40px;

  ${Media.lg`
    margin: 5px;
  `}
`;

export const DropdownButton = styled.button`
  ${commonButton}

  &:hover {
    ${(props) =>
      props.isToggle &&
      css`
        border-color: ${(props) => props.theme.borderOnToggle};
        background: ${(props) => props.theme.backgroundOnToggle};
        color: ${(props) => props.theme.colorOnToggle};
      `}
  }

  ${(props) =>
    props.isToggle &&
    css`
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      border-color: ${(props) => props.theme.borderOnToggle};
      background: ${(props) => props.theme.backgroundOnToggle};
      color: ${(props) => props.theme.colorOnToggle};
    `}
`;

export const DropdownButtonIcon = styled.i`
  transform: scaleY(1);
  ${(props) =>
    props.isToggle &&
    css`
      transform: scaleY(-1);
    `}
`;

export const DropdownContent = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  display: none;
  background: ${(props) => props.theme.background};
  border: 1px solid ${(props) => props.theme.border};
  z-index: 1;

  ${(props) =>
    props.isToggle &&
    css`
      display: block;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    `}
`;

export const DropdownOption = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 45px;
  transition: 0.2s all;
  padding: 0;
  background: ${(props) => props.theme.background};
  color: ${(props) => props.theme.color};
  font-size: 17px;
  font-weight: 500;
  text-align: center;
  user-select: none;
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.backgroundOnHover};
  }

  &:after {
    position: absolute;
    width: auto;
    height: 1px;
    background: ${(props) => props.theme.backgroundLine};
    right: 10px;
    left: 10px;
    bottom: 0;
    z-index: +1;
    content: '';
  }

  &:last-child:after {
    display: none;
  }

  &:hover {
    background: ${(props) => props.theme.backgroundOnHover};
    color: ${(props) => props.theme.colorOnHover};
  }
`;
